import ReviewShow from './Show'
import ReviewList from './List'

const reviewResource = {
  show: ReviewShow,
  list: ReviewList,
}

export default reviewResource
